import MainAddress from "..";
import axios from 'axios';
import { SetWithExpiry } from "../../util/sessionManager";
import { GetSerialProgram,GetWithExpiry } from "../../util/sessionManager";
export async function sendPostRequest () {
    // console.log(454554)
    // setInterval(async() => {
    //     try {
    //     let l ={}
    //       if (navigator.geolocation) {
    //         navigator.geolocation.getCurrentPosition(
    //            async (position) => {
                
    //              const response = await axios.post(MainAddress+'visitor/reg_visitorLocaton.php', {
            
              
              
    //               serial_program:GetSerialProgram(),
    //               code_visitor:GetWithExpiry("user").code,
    //               state:1,
                  
    //               lat: position.coords.latitude,
    //              lng: position.coords.longitude
    //             });

    //             if(response.data.success){
    //               SetWithExpiry("location",{lat:position.coords.latitude,lng:position.coords.longitude},180000)
    //               console.log('location:',"location sent")
    //             }else{
    //               console.log('location:',"location not sent!")
    //             }
              
    //            },
    //            (err) => {
    //             console.error('Location Error:', err.message);
                
    //            }
    //          );
              
          
          
    //      } else {
           
    //        console.error('Location Error:',"دسترسی به موقعیت مکانی وجود ندارد");
    //      }
           
            
          
    //     } catch (error) {
    //       console.error('Location Error:', error);
    //     }
    //   }, 180000); 
  };